!function() {
  class e extends HTMLElement {
    constructor() {
      super(), this.root = document.documentElement, this.updateHeight = this.updateHeight.bind(this), 
      this.handleClose = this.handleClose.bind(this);
    }
    connectedCallback() {
      this.observer = new IntersectionObserver(e => {
        e.forEach(e => {
          e.isIntersecting || this.hasAttribute("data-sticky") ? this.updateHeight() : (this.root.style.setProperty("--announcement-height", "0px"), 
          this.updateHeaderHeight());
        });
      }, {
        threshold: [ 0, 1 ]
      }), this.observer.observe(this), window.addEventListener("scroll", this.updateHeight, {
        passive: !0
      }), window.addEventListener("resize", this.updateHeight, {
        passive: !0
      });
      const e = this.querySelector('button[aria-label="Close"]');
      e && e.addEventListener("click", this.handleClose);
      const t = this.querySelector("fade-slider");
      t && window.innerWidth >= 1024 && sessionStorage.getItem("announcement-closed") && (t.style.display = "none", 
      this.root.classList.add("announcement-dismissed")), requestAnimationFrame(() => this.updateHeight());
    }
    disconnectedCallback() {
      this.observer && this.observer.disconnect(), window.removeEventListener("scroll", this.updateHeight), 
      window.removeEventListener("resize", this.updateHeight);
      const e = this.querySelector('button[aria-label="Close"]');
      e && e.removeEventListener("click", this.handleClose);
    }
    handleClose() {
      const e = this.querySelector("fade-slider");
      e && (e.style.display = "none"), sessionStorage.setItem("announcement-closed", "true"), 
      this.root.classList.add("announcement-dismissed"), this.updateHeight();
    }
    updateHeight() {
      const e = this.getBoundingClientRect();
      if (0 === e.height) return this.root.style.setProperty("--announcement-height", "0px"), 
      void this.updateHeaderHeight();
      if ("true" === this.getAttribute("data-sticky")) this.root.style.setProperty("--announcement-height", `${e.height}px`); else {
        const t = e.bottom > 0 ? Math.max(0, Math.min(e.height, e.bottom)) : 0;
        this.root.style.setProperty("--announcement-height", `${t}px`);
      }
      this.updateHeaderHeight();
    }
    updateHeaderHeight() {
      const e = document.querySelector("[data-header]") || document.querySelector("header"), t = e?.querySelector("site-header"), i = Math.round(t?.getBoundingClientRect().height) || 0;
      this.initialHeaderHeight && this._lastWindowWidth === window.innerWidth || (this.initialHeaderHeight = i, 
      this._lastWindowWidth = window.innerWidth);
      const s = parseFloat(this.root.style.getPropertyValue("--announcement-height")) || 0, n = s > 0 ? i + s - 2 : i;
      this.root.style.setProperty("--header-height", `${n}px`), this.root.style.setProperty("--base-header-height", `${this.initialHeaderHeight}px`);
      const o = this.getBoundingClientRect(), h = this.root.classList.contains("announcement-dismissed"), r = o.height > 0 && !h ? o.height : 0, a = r > 0 ? this.initialHeaderHeight + r - 2 : this.initialHeaderHeight;
      this.root.style.setProperty("--base-total-header-height", `${a}px`), this.root.style.setProperty("--base-announcement-height", `${r}px`);
    }
  }
  customElements.define("announcement-bar", e);
}();